// Tracks group rank/points trend in localStorage so we can show ▲▼ deltas
// without needing a backend snapshot table.

const KEY = "group_race_trend_v1";

type Snapshot = {
  ts: number;
  ranks: Record<string, { rank: number; points: number }>;
};

export function loadTrend(): Snapshot | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    return JSON.parse(raw) as Snapshot;
  } catch {
    return null;
  }
}

export function saveTrend(rows: { group_id: string; rank: number; total_points: number }[]) {
  const ranks: Snapshot["ranks"] = {};
  rows.forEach((r) => {
    ranks[r.group_id] = { rank: r.rank, points: r.total_points };
  });
  const snap: Snapshot = { ts: Date.now(), ranks };
  try {
    localStorage.setItem(KEY, JSON.stringify(snap));
  } catch {}
}

// Only persist a new snapshot if at least N hours have passed,
// so the delta represents real movement, not the same render.
export function maybeSaveTrend(
  rows: { group_id: string; rank: number; total_points: number }[],
  minHours = 12,
) {
  const prev = loadTrend();
  const now = Date.now();
  if (!prev || now - prev.ts > minHours * 3_600_000) {
    saveTrend(rows);
  }
}

export function getDelta(
  prev: Snapshot | null,
  groupId: string,
  currentRank: number,
  currentPoints: number,
) {
  const p = prev?.ranks[groupId];
  if (!p) return { rankDelta: 0, pointsDelta: 0, hasPrev: false };
  return {
    rankDelta: p.rank - currentRank, // positive = climbed up
    pointsDelta: currentPoints - p.points,
    hasPrev: true,
  };
}
